import styles from './SolutionsProblem.module.css'

const capabilities = [
  {
    title: 'Custom software',
    body: 'Purpose-built applications and internal tools designed around your exact workflows and the way your team actually operates.',
  },
  {
    title: 'Data management',
    body: 'Centralized, reliable systems for your data, so information lives in one place and every tool draws from the same source of truth.',
  },
  {
    title: 'Process improvement',
    body: 'We dig into the manual, repetitive work slowing your team down and redesign those processes to run faster with less effort.',
  },
  {
    title: 'AI with a purpose',
    body: 'Applied where it can meaningfully shorten a monotonous task or surface real insight, giving your team time back.',
  },
]

const SolutionsProblem = () => {
  return (
    <section id="what-we-build" className={styles.section}>
      <div className={styles.ambientLeft} />
      <div className={styles.ambientRight} />

      <div className="container">
        <div className={styles.header}>
          <div className={styles.sectionTag}>
            <span className={styles.tagNumber}>01</span>
            <span className={styles.tagLine} />
            <span className={styles.tagText}>What We Build</span>
          </div>
          <h2 className={styles.title}>Solutions built around how your business runs</h2>
          <p className={styles.subtitle}>
            Outdated systems, disconnected tools, manual work, untapped data: whatever is
            slowing your business down, we find the fix and build it.
          </p>
        </div>

        <div className={styles.grid}>
          {capabilities.map((item, i) => (
            <div key={i} className={styles.card}>
              <span className={styles.cardNumber}>{String(i + 1).padStart(2, '0')}</span>
              <h3 className={styles.cardTitle}>{item.title}</h3>
              <p className={styles.cardBody}>{item.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default SolutionsProblem
